module.exports = {
	"2": {
		"0": {
			"73": [
				1
			],
			"102": [
				1
			],
			"257": [
				1
			],
			"307": [
				1
			],
			"318": [
				1
			],
			"352": [
				1
			],
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"743": [
				1
			],
			"744": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"83": [
				1
			],
			"122": [
				1
			],
			"129": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"366": [
				1
			],
			"557": [
				1
			],
			"607": [
				1
			],
			"863": [
				1
			],
			"885": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"84": [
				1
			],
			"123": [
				1
			],
			"130": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"367": [
				1
			],
			"558": [
				1
			],
			"608": [
				1
			],
			"864": [
				1
			],
			"886": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"85": [
				1
			],
			"124": [
				1
			],
			"131": [
				1
			],
			"140": [
				1
			],
			"184": [
				1
			],
			"197": [
				1
			],
			"368": [
				1
			],
			"559": [
				1
			],
			"609": [
				1
			],
			"865": [
				1
			],
			"887": [
				1
			]
		},
		"4": {
			"24": [
				1
			],
			"86": [
				1
			],
			"125": [
				1
			],
			"132": [
				1
			],
			"141": [
				1
			],
			"185": [
				1
			],
			"198": [
				1
			],
			"369": [
				1
			],
			"560": [
				1
			],
			"610": [
				1
			],
			"866": [
				1
			],
			"888": [
				1
			]
		},
		"5": {
			"25": [
				1
			],
			"87": [
				1
			],
			"126": [
				1
			],
			"133": [
				1
			],
			"142": [
				1
			],
			"186": [
				1
			],
			"199": [
				1
			],
			"370": [
				1
			],
			"561": [
				1
			],
			"611": [
				1
			],
			"867": [
				1
			],
			"889": [
				1
			]
		},
		"6": {
			"26": [
				1
			],
			"88": [
				1
			],
			"127": [
				1
			],
			"134": [
				1
			],
			"143": [
				1
			],
			"187": [
				1
			],
			"200": [
				1
			],
			"371": [
				1
			],
			"562": [
				1
			],
			"612": [
				1
			],
			"868": [
				1
			],
			"890": [
				1
			]
		},
		"7": {
			"27": [
				1
			],
			"89": [
				1
			],
			"128": [
				1
			],
			"135": [
				1
			],
			"144": [
				1
			],
			"188": [
				1
			],
			"201": [
				1
			],
			"372": [
				1
			],
			"563": [
				1
			],
			"613": [
				1
			],
			"869": [
				1
			],
			"891": [
				1
			]
		}
	},
	"3": {
		"0": {
			"73": [
				1
			],
			"74": [
				1
			],
			"102": [
				1
			],
			"257": [
				1
			],
			"307": [
				1
			],
			"318": [
				1
			],
			"352": [
				1
			],
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"737": [
				1
			],
			"882": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"83": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"366": [
				1
			],
			"557": [
				1
			],
			"607": [
				1
			],
			"788": [
				1
			],
			"791": [
				1
			],
			"842": [
				1
			],
			"845": [
				1
			],
			"848": [
				1
			],
			"896": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"84": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"367": [
				1
			],
			"558": [
				1
			],
			"608": [
				1
			],
			"789": [
				1
			],
			"792": [
				1
			],
			"843": [
				1
			],
			"846": [
				1
			],
			"849": [
				1
			],
			"897": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"85": [
				1
			],
			"140": [
				1
			],
			"184": [
				1
			],
			"197": [
				1
			],
			"368": [
				1
			],
			"559": [
				1
			],
			"609": [
				1
			],
			"790": [
				1
			],
			"793": [
				1
			],
			"844": [
				1
			],
			"847": [
				1
			],
			"850": [
				1
			],
			"898": [
				1
			]
		},
		"4": {
			"17": [
				1
			],
			"176": [
				1
			],
			"362": [
				1
			]
		},
		"5": {
			"13": [
				1
			],
			"172": [
				1
			],
			"358": [
				1
			]
		},
		"6": {
			"18": [
				1
			],
			"177": [
				1
			],
			"363": [
				1
			]
		},
		"7": {
			"14": [
				1
			],
			"173": [
				1
			],
			"359": [
				1
			]
		}
	},
	"4": {
		"0": {
			"73": [
				1
			],
			"74": [
				1
			],
			"102": [
				1
			],
			"137": [
				1
			],
			"257": [
				1
			],
			"281": [
				1
			],
			"307": [
				1
			],
			"318": [
				1
			],
			"319": [
				1
			],
			"320": [
				1
			],
			"352": [
				1
			],
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"755": [
				1
			],
			"798": [
				1
			],
			"882": [
				1
			],
			"927": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"83": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"366": [
				1
			],
			"557": [
				1
			],
			"607": [
				1
			],
			"836": [
				1
			],
			"896": [
				1
			],
			"903": [
				1
			],
			"909": [
				1
			],
			"914": [
				1
			],
			"920": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"84": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"367": [
				1
			],
			"558": [
				1
			],
			"608": [
				1
			],
			"837": [
				1
			],
			"897": [
				1
			],
			"904": [
				1
			],
			"910": [
				1
			],
			"915": [
				1
			],
			"921": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"85": [
				1
			],
			"140": [
				1
			],
			"184": [
				1
			],
			"197": [
				1
			],
			"368": [
				1
			],
			"559": [
				1
			],
			"609": [
				1
			],
			"838": [
				1
			],
			"898": [
				1
			],
			"905": [
				1
			],
			"911": [
				1
			],
			"916": [
				1
			],
			"922": [
				1
			]
		},
		"4": {
			"24": [
				1
			],
			"86": [
				1
			],
			"141": [
				1
			],
			"185": [
				1
			],
			"198": [
				1
			],
			"369": [
				1
			],
			"560": [
				1
			],
			"610": [
				1
			],
			"839": [
				1
			],
			"899": [
				1
			],
			"906": [
				1
			],
			"912": [
				1
			],
			"917": [
				1
			],
			"923": [
				1
			]
		},
		"5": {
			"25": [
				1
			],
			"87": [
				1
			],
			"142": [
				1
			],
			"186": [
				1
			],
			"199": [
				1
			],
			"370": [
				1
			],
			"561": [
				1
			],
			"611": [
				1
			],
			"840": [
				1
			],
			"900": [
				1
			],
			"907": [
				1
			],
			"913": [
				1
			],
			"918": [
				1
			],
			"924": [
				1
			]
		},
		"6": {
			"26": [
				1
			],
			"88": [
				1
			],
			"143": [
				1
			],
			"187": [
				1
			],
			"200": [
				1
			],
			"371": [
				1
			],
			"562": [
				1
			],
			"901": [
				1
			],
			"908": [
				1
			],
			"919": [
				1
			],
			"925": [
				1
			]
		},
		"7": {
			"17": [
				1
			],
			"176": [
				1
			],
			"362": [
				1
			]
		},
		"8": {
			"13": [
				1
			],
			"172": [
				1
			],
			"358": [
				1
			]
		},
		"9": {
			"18": [
				1
			],
			"177": [
				1
			],
			"363": [
				1
			]
		},
		"10": {
			"14": [
				1
			],
			"173": [
				1
			],
			"359": [
				1
			]
		},
		"11": {
			"19": [
				1
			],
			"178": [
				1
			],
			"364": [
				1
			]
		},
		"12": {
			"15": [
				1
			],
			"174": [
				1
			],
			"360": [
				1
			]
		},
		"13": {
			"20": [
				1
			],
			"179": [
				1
			],
			"365": [
				1
			]
		},
		"14": {
			"16": [
				1
			],
			"175": [
				1
			],
			"361": [
				1
			]
		}
	},
	"5": {
		"0": {
			"349": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"689": [
				1
			]
		}
	},
	"6": {
		"0": {
			"73": [
				1
			],
			"82": [
				1
			],
			"102": [
				1
			],
			"257": [
				1
			],
			"296": [
				1
			],
			"297": [
				1
			],
			"298": [
				1
			],
			"299": [
				1
			],
			"305": [
				1
			],
			"307": [
				1
			],
			"308": [
				1
			],
			"309": [
				1
			],
			"315": [
				1
			],
			"318": [
				1
			],
			"320": [
				1
			],
			"328": [
				1
			],
			"329": [
				1
			],
			"330": [
				1
			],
			"331": [
				1
			],
			"332": [
				1
			],
			"337": [
				1
			],
			"338": [
				1
			],
			"339": [
				1
			],
			"340": [
				1
			],
			"341": [
				1
			],
			"342": [
				1
			],
			"352": [
				1
			],
			"403": [
				1
			],
			"427": [
				1
			],
			"443": [
				1
			],
			"445": [
				1
			],
			"505": [
				1
			],
			"506": [
				1
			],
			"507": [
				1
			],
			"513": [
				1
			],
			"514": [
				1
			],
			"527": [
				1
			],
			"534": [
				1
			],
			"535": [
				1
			],
			"536": [
				1
			],
			"537": [
				1
			],
			"538": [
				1
			],
			"539": [
				1
			],
			"540": [
				1
			],
			"543": [
				1
			],
			"544": [
				1
			],
			"550": [
				1
			],
			"551": [
				1
			],
			"599": [
				1
			],
			"623": [
				1
			],
			"627": [
				1
			],
			"638": [
				1
			],
			"687": [
				1
			],
			"688": [
				1
			],
			"713": [
				1
			],
			"732": [
				1
			],
			"739": [
				1
			],
			"798": [
				1
			],
			"894": [
				1,
				1
			],
			"1861": [
				1
			],
			"1870": [
				1,
				1
			],
			"1871": [
				1
			],
			"1872": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"76": [
				1
			],
			"83": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"190": [
				1
			],
			"195": [
				1
			],
			"300": [
				1
			],
			"310": [
				1
			],
			"333": [
				1
			],
			"366": [
				1
			],
			"508": [
				1
			],
			"545": [
				1
			],
			"552": [
				1
			],
			"557": [
				1
			],
			"594": [
				1
			],
			"618": [
				1
			],
			"708": [
				1
			],
			"745": [
				1
			],
			"750": [
				1
			],
			"759": [
				1
			],
			"896": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"77": [
				1
			],
			"84": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"191": [
				1
			],
			"196": [
				1
			],
			"301": [
				1
			],
			"311": [
				1
			],
			"334": [
				1
			],
			"367": [
				1
			],
			"509": [
				1
			],
			"546": [
				1
			],
			"553": [
				1
			],
			"558": [
				1
			],
			"595": [
				1
			],
			"619": [
				1
			],
			"709": [
				1
			],
			"746": [
				1
			],
			"751": [
				1
			],
			"760": [
				1
			],
			"897": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"78": [
				1
			],
			"85": [
				1
			],
			"140": [
				1
			],
			"184": [
				1
			],
			"192": [
				1
			],
			"197": [
				1
			],
			"302": [
				1
			],
			"312": [
				1
			],
			"335": [
				1
			],
			"368": [
				1
			],
			"510": [
				1
			],
			"547": [
				1
			],
			"554": [
				1
			],
			"559": [
				1
			],
			"596": [
				1
			],
			"620": [
				1
			],
			"710": [
				1
			],
			"747": [
				1
			],
			"752": [
				1
			],
			"761": [
				1
			],
			"898": [
				1
			]
		},
		"4": {
			"24": [
				1
			],
			"79": [
				1
			],
			"86": [
				1
			],
			"141": [
				1
			],
			"185": [
				1
			],
			"193": [
				1
			],
			"198": [
				1
			],
			"303": [
				1
			],
			"313": [
				1
			],
			"336": [
				1
			],
			"369": [
				1
			],
			"511": [
				1
			],
			"548": [
				1
			],
			"555": [
				1
			],
			"560": [
				1
			],
			"597": [
				1
			],
			"621": [
				1
			],
			"711": [
				1
			],
			"748": [
				1
			],
			"753": [
				1
			],
			"762": [
				1
			],
			"899": [
				1
			]
		},
		"5": {
			"25": [
				1
			],
			"80": [
				1
			],
			"87": [
				1
			],
			"142": [
				1
			],
			"186": [
				1
			],
			"194": [
				1
			],
			"199": [
				1
			],
			"304": [
				1
			],
			"314": [
				1
			],
			"370": [
				1
			],
			"512": [
				1
			],
			"549": [
				1
			],
			"556": [
				1
			],
			"561": [
				1
			],
			"598": [
				1
			],
			"622": [
				1
			],
			"712": [
				1
			],
			"749": [
				1
			],
			"754": [
				1
			],
			"763": [
				1
			],
			"900": [
				1
			]
		}
	},
	"7": {
		"0": {
			"1": [
				1
			],
			"74": [
				1
			],
			"103": [
				1
			],
			"136": [
				1
			],
			"137": [
				1
			],
			"256": [
				1
			],
			"260": [
				1
			],
			"261": [
				1
			],
			"278": [
				1
			],
			"281": [
				1
			],
			"282": [
				1
			],
			"306": [
				1
			],
			"321": [
				1
			],
			"322": [
				1
			],
			"323": [
				1
			],
			"324": [
				1
			],
			"325": [
				1
			],
			"326": [
				1
			],
			"327": [
				1
			],
			"343": [
				1
			],
			"345": [
				1
			],
			"346": [
				1
			],
			"349": [
				1
			],
			"412": [
				1
			],
			"415": [
				1
			],
			"416": [
				1
			],
			"417": [
				1
			],
			"418": [
				1
			],
			"425": [
				1
			],
			"426": [
				1
			],
			"428": [
				1
			],
			"429": [
				1
			],
			"432": [
				1
			],
			"433": [
				1
			],
			"434": [
				1
			],
			"435": [
				1
			],
			"436": [
				1
			],
			"437": [
				1
			],
			"439": [
				1
			],
			"442": [
				1
			],
			"443": [
				1
			],
			"462": [
				1
			],
			"464": [
				1
			],
			"465": [
				1
			],
			"515": [
				1
			],
			"516": [
				1
			],
			"517": [
				1
			],
			"518": [
				1
			],
			"525": [
				1
			],
			"526": [
				1
			],
			"528": [
				1
			],
			"529": [
				1
			],
			"530": [
				1
			],
			"531": [
				1
			],
			"532": [
				1
			],
			"533": [
				1
			],
			"599": [
				1
			],
			"600": [
				1
			],
			"605": [
				1
			],
			"614": [
				1
			],
			"615": [
				1
			],
			"616": [
				1
			],
			"617": [
				1
			],
			"624": [
				1
			],
			"625": [
				1
			],
			"626": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			],
			"693": [
				1
			],
			"695": [
				1
			],
			"696": [
				1
			],
			"697": [
				1
			],
			"701": [
				1
			],
			"705": [
				1
			],
			"706": [
				1
			],
			"714": [
				1
			],
			"715": [
				1
			],
			"720": [
				1
			],
			"721": [
				1
			],
			"722": [
				1
			],
			"723": [
				1
			],
			"724": [
				1
			],
			"725": [
				1
			],
			"726": [
				1
			],
			"730": [
				1
			],
			"738": [
				1
			],
			"795": [
				1
			],
			"796": [
				1
			],
			"841": [
				1
			],
			"862": [
				1
			],
			"870": [
				1
			],
			"871": [
				1
			],
			"872": [
				1
			],
			"883": [
				1
			],
			"895": [
				1
			],
			"902": [
				1
			],
			"928": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"83": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"273": [
				1
			],
			"419": [
				1
			],
			"519": [
				1
			],
			"648": [
				1
			],
			"664": [
				1
			],
			"698": [
				1
			],
			"727": [
				1
			],
			"729": [
				1
			],
			"731": [
				1
			],
			"734": [
				1
			],
			"756": [
				1
			],
			"794": [
				1
			],
			"860": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"84": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"274": [
				1
			],
			"420": [
				1
			],
			"520": [
				1
			],
			"649": [
				1
			],
			"665": [
				1
			],
			"699": [
				1
			],
			"728": [
				1
			],
			"735": [
				1
			],
			"757": [
				1
			],
			"859": [
				1
			],
			"861": [
				1
			]
		},
		"3": {
			"2": [
				1
			],
			"148": [
				1
			],
			"154": [
				1
			],
			"160": [
				1
			],
			"641": [
				1
			],
			"652": [
				1
			]
		},
		"4": {
			"5": [
				1
			],
			"149": [
				1
			],
			"155": [
				1
			],
			"163": [
				1
			],
			"642": [
				1
			],
			"655": [
				1
			]
		},
		"5": {
			"7": [
				1
			],
			"150": [
				1
			],
			"156": [
				1
			],
			"165": [
				1
			],
			"643": [
				1
			],
			"657": [
				1
			]
		},
		"6": {
			"151": [
				1
			],
			"157": [
				1
			],
			"166": [
				1
			],
			"644": [
				1
			],
			"658": [
				1
			],
			"930": [
				1
			]
		},
		"7": {
			"9": [
				1
			],
			"152": [
				1
			],
			"158": [
				1
			],
			"168": [
				1
			],
			"645": [
				1
			],
			"660": [
				1
			]
		},
		"8": {
			"12": [
				1
			],
			"153": [
				1
			],
			"159": [
				1
			],
			"171": [
				1
			],
			"646": [
				1
			],
			"663": [
				1
			]
		},
		"9": {
			"66": [
				1
			],
			"255": [
				1
			],
			"354": [
				1
			],
			"355": [
				1
			],
			"438": [
				1
			],
			"680": [
				1
			]
		},
		"10": {
			"67": [
				1
			],
			"258": [
				1
			],
			"356": [
				1
			],
			"357": [
				1
			],
			"681": [
				1
			]
		},
		"11": {
			"81": [
				1
			],
			"353": [
				1
			],
			"440": [
				1
			],
			"441": [
				1
			],
			"690": [
				1
			]
		},
		"12": {
			"68": [
				1
			],
			"259": [
				1
			],
			"682": [
				1
			]
		},
		"13": {
			"69": [
				1
			],
			"146": [
				1
			],
			"180": [
				1
			],
			"262": [
				1
			],
			"650": [
				1
			],
			"683": [
				1
			],
			"694": [
				1
			],
			"740": [
				1
			]
		},
		"14": {
			"70": [
				1
			],
			"263": [
				1
			],
			"684": [
				1
			]
		},
		"15": {
			"72": [
				1
			],
			"277": [
				1
			],
			"686": [
				1
			]
		},
		"16": {
			"147": [
				1
			],
			"181": [
				1
			],
			"275": [
				1
			],
			"276": [
				1
			],
			"741": [
				1
			]
		}
	},
	"8": {
		"0": {
			"74": [
				1
			],
			"103": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			]
		},
		"1": {
			"195": [
				1
			],
			"664": [
				1
			]
		},
		"2": {
			"196": [
				1
			],
			"665": [
				1
			]
		},
		"3": {
			"197": [
				1
			],
			"666": [
				1
			]
		},
		"4": {
			"198": [
				1
			],
			"667": [
				1
			]
		}
	},
	"9": {
		"0": {
			"74": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			]
		},
		"1": {
			"195": [
				1
			],
			"664": [
				1
			]
		},
		"2": {
			"196": [
				1
			],
			"665": [
				1
			]
		}
	},
	"10": {
		"0": {
			"1": [
				1
			],
			"74": [
				1
			],
			"103": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"11": {
		"0": {
			"74": [
				1
			],
			"103": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"12": {
		"0": {
			"74": [
				1
			],
			"103": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			]
		}
	},
	"13": {
		"0": {
			"283": [
				1
			],
			"284": [
				1
			],
			"285": [
				1
			],
			"286": [
				1
			],
			"287": [
				1
			],
			"288": [
				1
			],
			"289": [
				1
			],
			"290": [
				1
			],
			"291": [
				1
			],
			"292": [
				1
			],
			"293": [
				1
			],
			"294": [
				1
			],
			"295": [
				1
			],
			"316": [
				1
			],
			"452": [
				1
			],
			"453": [
				1
			],
			"454": [
				1
			],
			"455": [
				1
			],
			"456": [
				1
			],
			"457": [
				1
			],
			"458": [
				1
			],
			"459": [
				1
			],
			"460": [
				1
			],
			"461": [
				1
			]
		}
	},
	"14": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"15": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"16": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"17": {
		"0": {
			"348": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"18": {
		"0": {
			"65": [
				1
			],
			"74": [
				1
			],
			"253": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"350": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"601": [
				1
			],
			"606": [
				1
			],
			"647": [
				1
			],
			"679": [
				1
			],
			"689": [
				1
			],
			"742": [
				1
			],
			"797": [
				1
			],
			"880": [
				1
			],
			"884": [
				1
			],
			"895": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"195": [
				1
			],
			"664": [
				1
			],
			"698": [
				1
			],
			"734": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"196": [
				1
			],
			"665": [
				1
			],
			"699": [
				1
			],
			"735": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"197": [
				1
			],
			"666": [
				1
			],
			"700": [
				1
			],
			"736": [
				1
			]
		}
	},
	"19": {
		"0": {
			"74": [
				1
			],
			"103": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"606": [
				1
			],
			"689": [
				1
			],
			"714": [
				1
			],
			"902": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"664": [
				1
			],
			"873": [
				1
			],
			"875": [
				1
			],
			"877": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"196": [
				1
			],
			"665": [
				1
			],
			"874": [
				1
			],
			"876": [
				1
			],
			"878": [
				1
			]
		}
	},
	"20": {
		"0": {
			"74": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"689": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"664": [
				1
			],
			"851": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"665": [
				1
			],
			"852": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"140": [
				1
			],
			"184": [
				1
			],
			"197": [
				1
			],
			"666": [
				1
			],
			"853": [
				1
			]
		},
		"4": {
			"24": [
				1
			],
			"141": [
				1
			],
			"185": [
				1
			],
			"198": [
				1
			],
			"667": [
				1
			],
			"854": [
				1
			]
		},
		"5": {
			"25": [
				1
			],
			"142": [
				1
			],
			"186": [
				1
			],
			"199": [
				1
			],
			"668": [
				1
			],
			"855": [
				1
			]
		},
		"6": {
			"26": [
				1
			],
			"143": [
				1
			],
			"187": [
				1
			],
			"200": [
				1
			],
			"669": [
				1
			],
			"856": [
				1
			]
		},
		"7": {
			"27": [
				1
			],
			"144": [
				1
			],
			"188": [
				1
			],
			"201": [
				1
			],
			"670": [
				1
			],
			"857": [
				1
			]
		},
		"8": {
			"28": [
				1
			],
			"145": [
				1
			],
			"189": [
				1
			],
			"202": [
				1
			],
			"671": [
				1
			],
			"858": [
				1
			]
		}
	},
	"21": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"23": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"24": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"25": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"26": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"27": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"28": {
		"0": {
			"74": [
				1
			],
			"103": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"603": [
				1
			],
			"604": [
				1
			],
			"606": [
				1
			],
			"926": [
				1
			]
		}
	},
	"29": {
		"0": {
			"74": [
				1
			],
			"254": [
				1
			],
			"349": [
				1
			],
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"83": [
				1
			],
			"195": [
				1
			],
			"366": [
				1
			],
			"466": [
				1
			],
			"557": [
				1
			],
			"799": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"84": [
				1
			],
			"196": [
				1
			],
			"367": [
				1
			],
			"467": [
				1
			],
			"558": [
				1
			],
			"800": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"85": [
				1
			],
			"197": [
				1
			],
			"368": [
				1
			],
			"468": [
				1
			],
			"559": [
				1
			],
			"801": [
				1
			]
		},
		"4": {
			"24": [
				1
			],
			"86": [
				1
			],
			"198": [
				1
			],
			"369": [
				1
			],
			"469": [
				1
			],
			"560": [
				1
			],
			"802": [
				1
			]
		},
		"5": {
			"25": [
				1
			],
			"87": [
				1
			],
			"199": [
				1
			],
			"370": [
				1
			],
			"470": [
				1
			],
			"561": [
				1
			],
			"803": [
				1
			]
		},
		"6": {
			"26": [
				1
			],
			"88": [
				1
			],
			"200": [
				1
			],
			"371": [
				1
			],
			"471": [
				1
			],
			"562": [
				1
			],
			"804": [
				1
			]
		},
		"7": {
			"27": [
				1
			],
			"89": [
				1
			],
			"201": [
				1
			],
			"372": [
				1
			],
			"472": [
				1
			],
			"563": [
				1
			],
			"805": [
				1
			]
		},
		"8": {
			"28": [
				1
			],
			"90": [
				1
			],
			"202": [
				1
			],
			"373": [
				1
			],
			"473": [
				1
			],
			"564": [
				1
			],
			"806": [
				1
			]
		},
		"9": {
			"29": [
				1
			],
			"91": [
				1
			],
			"203": [
				1
			],
			"374": [
				1
			],
			"474": [
				1
			],
			"565": [
				1
			],
			"807": [
				1
			]
		},
		"10": {
			"30": [
				1
			],
			"92": [
				1
			],
			"204": [
				1
			],
			"375": [
				1
			],
			"475": [
				1
			],
			"566": [
				1
			],
			"808": [
				1
			]
		},
		"11": {
			"31": [
				1
			],
			"93": [
				1
			],
			"205": [
				1
			],
			"376": [
				1
			],
			"476": [
				1
			],
			"567": [
				1
			],
			"809": [
				1
			]
		},
		"12": {
			"32": [
				1
			],
			"94": [
				1
			],
			"206": [
				1
			],
			"377": [
				1
			],
			"477": [
				1
			],
			"568": [
				1
			],
			"810": [
				1
			]
		},
		"13": {
			"33": [
				1
			],
			"95": [
				1
			],
			"207": [
				1
			],
			"378": [
				1
			],
			"478": [
				1
			],
			"569": [
				1
			],
			"811": [
				1
			]
		},
		"14": {
			"34": [
				1
			],
			"96": [
				1
			],
			"208": [
				1
			],
			"379": [
				1
			],
			"479": [
				1
			],
			"570": [
				1
			],
			"812": [
				1
			]
		},
		"15": {
			"35": [
				1
			],
			"97": [
				1
			],
			"209": [
				1
			],
			"380": [
				1
			],
			"480": [
				1
			],
			"571": [
				1
			],
			"813": [
				1
			]
		},
		"16": {
			"36": [
				1
			],
			"98": [
				1
			],
			"210": [
				1
			],
			"381": [
				1
			],
			"481": [
				1
			],
			"572": [
				1
			],
			"814": [
				1
			]
		},
		"17": {
			"37": [
				1
			],
			"99": [
				1
			],
			"211": [
				1
			],
			"382": [
				1
			],
			"482": [
				1
			],
			"573": [
				1
			],
			"815": [
				1
			]
		},
		"18": {
			"38": [
				1
			],
			"100": [
				1
			],
			"212": [
				1
			],
			"383": [
				1
			],
			"483": [
				1
			],
			"574": [
				1
			],
			"816": [
				1
			]
		},
		"19": {
			"39": [
				1
			],
			"101": [
				1
			],
			"213": [
				1
			],
			"384": [
				1
			],
			"484": [
				1
			],
			"575": [
				1
			],
			"817": [
				1
			]
		},
		"20": {
			"40": [
				1
			],
			"104": [
				1
			],
			"214": [
				1
			],
			"385": [
				1
			],
			"485": [
				1
			],
			"576": [
				1
			],
			"818": [
				1
			]
		},
		"21": {
			"41": [
				1
			],
			"105": [
				1
			],
			"215": [
				1
			],
			"386": [
				1
			],
			"486": [
				1
			],
			"577": [
				1
			],
			"819": [
				1
			]
		},
		"22": {
			"42": [
				1
			],
			"106": [
				1
			],
			"216": [
				1
			],
			"387": [
				1
			],
			"487": [
				1
			],
			"578": [
				1
			],
			"820": [
				1
			]
		},
		"23": {
			"43": [
				1
			],
			"107": [
				1
			],
			"217": [
				1
			],
			"388": [
				1
			],
			"488": [
				1
			],
			"579": [
				1
			],
			"821": [
				1
			]
		},
		"24": {
			"44": [
				1
			],
			"108": [
				1
			],
			"218": [
				1
			],
			"389": [
				1
			],
			"489": [
				1
			],
			"580": [
				1
			],
			"822": [
				1
			]
		},
		"25": {
			"45": [
				1
			],
			"109": [
				1
			],
			"219": [
				1
			],
			"390": [
				1
			],
			"490": [
				1
			],
			"581": [
				1
			],
			"823": [
				1
			]
		},
		"26": {
			"46": [
				1
			],
			"110": [
				1
			],
			"220": [
				1
			],
			"391": [
				1
			],
			"491": [
				1
			],
			"582": [
				1
			],
			"824": [
				1
			]
		},
		"27": {
			"47": [
				1
			],
			"111": [
				1
			],
			"221": [
				1
			],
			"392": [
				1
			],
			"492": [
				1
			],
			"583": [
				1
			],
			"825": [
				1
			]
		},
		"28": {
			"48": [
				1
			],
			"112": [
				1
			],
			"222": [
				1
			],
			"393": [
				1
			],
			"493": [
				1
			],
			"584": [
				1
			],
			"826": [
				1
			]
		},
		"29": {
			"49": [
				1
			],
			"113": [
				1
			],
			"223": [
				1
			],
			"394": [
				1
			],
			"494": [
				1
			],
			"585": [
				1
			],
			"827": [
				1
			]
		},
		"30": {
			"50": [
				1
			],
			"114": [
				1
			],
			"224": [
				1
			],
			"395": [
				1
			],
			"495": [
				1
			],
			"586": [
				1
			],
			"828": [
				1
			]
		},
		"31": {
			"51": [
				1
			],
			"115": [
				1
			],
			"225": [
				1
			],
			"396": [
				1
			],
			"496": [
				1
			],
			"587": [
				1
			],
			"829": [
				1
			]
		},
		"32": {
			"52": [
				1
			],
			"116": [
				1
			],
			"226": [
				1
			],
			"397": [
				1
			],
			"497": [
				1
			],
			"588": [
				1
			],
			"830": [
				1
			]
		},
		"33": {
			"53": [
				1
			],
			"117": [
				1
			],
			"227": [
				1
			],
			"398": [
				1
			],
			"498": [
				1
			],
			"589": [
				1
			],
			"831": [
				1
			]
		},
		"34": {
			"54": [
				1
			],
			"118": [
				1
			],
			"228": [
				1
			],
			"399": [
				1
			],
			"499": [
				1
			],
			"590": [
				1
			],
			"832": [
				1
			]
		},
		"35": {
			"55": [
				1
			],
			"119": [
				1
			],
			"229": [
				1
			],
			"400": [
				1
			],
			"500": [
				1
			],
			"591": [
				1
			],
			"833": [
				1
			]
		},
		"36": {
			"56": [
				1
			],
			"120": [
				1
			],
			"230": [
				1
			],
			"401": [
				1
			],
			"501": [
				1
			],
			"592": [
				1
			],
			"834": [
				1
			]
		},
		"37": {
			"57": [
				1
			],
			"121": [
				1
			],
			"231": [
				1
			],
			"402": [
				1
			],
			"502": [
				1
			],
			"593": [
				1
			],
			"835": [
				1
			]
		}
	},
	"30": {
		"0": {
			"74": [
				1
			],
			"103": [
				1
			],
			"256": [
				1
			],
			"279": [
				1
			],
			"306": [
				1
			],
			"343": [
				1
			],
			"344": [
				1
			],
			"346": [
				1
			],
			"347": [
				1
			],
			"349": [
				1
			],
			"350": [
				1
			],
			"403": [
				1
			],
			"412": [
				1
			],
			"415": [
				1
			],
			"426": [
				1
			],
			"443": [
				1
			],
			"446": [
				1
			],
			"447": [
				1
			],
			"448": [
				1
			],
			"449": [
				1
			],
			"450": [
				1
			],
			"451": [
				1
			],
			"515": [
				1
			],
			"526": [
				1
			],
			"599": [
				1
			],
			"601": [
				1
			],
			"602": [
				1
			],
			"606": [
				1
			],
			"617": [
				1
			],
			"625": [
				1
			],
			"628": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			],
			"697": [
				1
			],
			"701": [
				1
			],
			"702": [
				1
			],
			"703": [
				1
			],
			"704": [
				1
			],
			"742": [
				1
			],
			"880": [
				1
			],
			"895": [
				1
			],
			"902": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"83": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"664": [
				1
			],
			"698": [
				1
			],
			"734": [
				1
			],
			"756": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"84": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"665": [
				1
			],
			"699": [
				1
			],
			"735": [
				1
			],
			"757": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"85": [
				1
			],
			"140": [
				1
			],
			"184": [
				1
			],
			"197": [
				1
			],
			"666": [
				1
			],
			"700": [
				1
			],
			"736": [
				1
			],
			"758": [
				1
			]
		},
		"4": {
			"3": [
				1
			],
			"161": [
				1
			],
			"653": [
				1
			]
		},
		"5": {
			"4": [
				1
			],
			"162": [
				1
			],
			"654": [
				1
			]
		},
		"6": {
			"6": [
				1
			],
			"164": [
				1
			],
			"656": [
				1
			]
		},
		"7": {
			"8": [
				1
			],
			"167": [
				1
			],
			"659": [
				1
			]
		},
		"8": {
			"10": [
				1
			],
			"169": [
				1
			],
			"661": [
				1
			]
		},
		"9": {
			"11": [
				1
			],
			"170": [
				1
			],
			"662": [
				1
			]
		}
	},
	"31": {
		"0": {
			"60": [
				1
			],
			"74": [
				1
			],
			"103": [
				1
			],
			"137": [
				1
			],
			"242": [
				1
			],
			"243": [
				1
			],
			"244": [
				1
			],
			"245": [
				1
			],
			"247": [
				1
			],
			"256": [
				1
			],
			"280": [
				1
			],
			"281": [
				1
			],
			"306": [
				1
			],
			"317": [
				1
			],
			"349": [
				1
			],
			"403": [
				1
			],
			"404": [
				1
			],
			"407": [
				1
			],
			"408": [
				1
			],
			"421": [
				1
			],
			"422": [
				1
			],
			"423": [
				1
			],
			"424": [
				1
			],
			"443": [
				1
			],
			"444": [
				1
			],
			"465": [
				1
			],
			"521": [
				1
			],
			"522": [
				1
			],
			"523": [
				1
			],
			"524": [
				1
			],
			"599": [
				1
			],
			"628": [
				1
			],
			"637": [
				1
			],
			"674": [
				1
			],
			"691": [
				1
			],
			"764": [
				1
			],
			"773": [
				1
			],
			"774": [
				1
			],
			"779": [
				1
			],
			"879": [
				1
			],
			"881": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"629": [
				1
			],
			"633": [
				1
			],
			"664": [
				1
			],
			"765": [
				1
			],
			"769": [
				1
			],
			"775": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"630": [
				1
			],
			"634": [
				1
			],
			"665": [
				1
			],
			"766": [
				1
			],
			"770": [
				1
			],
			"776": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"140": [
				1
			],
			"184": [
				1
			],
			"197": [
				1
			],
			"631": [
				1
			],
			"635": [
				1
			],
			"666": [
				1
			],
			"767": [
				1
			],
			"771": [
				1
			],
			"777": [
				1
			]
		},
		"4": {
			"24": [
				1
			],
			"141": [
				1
			],
			"185": [
				1
			],
			"198": [
				1
			],
			"632": [
				1
			],
			"636": [
				1
			],
			"667": [
				1
			],
			"768": [
				1
			],
			"772": [
				1
			],
			"778": [
				1
			]
		},
		"5": {
			"62": [
				1
			],
			"233": [
				1
			],
			"241": [
				1
			],
			"248": [
				1
			],
			"406": [
				1
			],
			"676": [
				1
			]
		},
		"6": {
			"61": [
				1
			],
			"232": [
				1
			],
			"240": [
				1
			],
			"246": [
				1
			],
			"405": [
				1
			],
			"675": [
				1
			]
		},
		"7": {
			"58": [
				1
			],
			"234": [
				1
			],
			"236": [
				1
			],
			"238": [
				1
			],
			"672": [
				1
			]
		},
		"8": {
			"59": [
				1
			],
			"235": [
				1
			],
			"237": [
				1
			],
			"239": [
				1
			],
			"673": [
				1
			]
		}
	},
	"32": {
		"0": {
			"73": [
				1
			],
			"102": [
				1
			],
			"256": [
				1
			],
			"257": [
				1
			],
			"306": [
				1
			],
			"307": [
				1
			],
			"318": [
				1
			],
			"352": [
				1
			],
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"739": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"122": [
				1
			],
			"129": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"366": [
				1
			],
			"557": [
				1
			],
			"607": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"123": [
				1
			],
			"130": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"367": [
				1
			],
			"558": [
				1
			],
			"608": [
				1
			]
		},
		"3": {
			"23": [
				1
			],
			"124": [
				1
			],
			"131": [
				1
			],
			"140": [
				1
			],
			"184": [
				1
			],
			"197": [
				1
			],
			"368": [
				1
			],
			"559": [
				1
			],
			"609": [
				1
			]
		},
		"4": {
			"17": [
				1
			],
			"176": [
				1
			],
			"362": [
				1
			]
		},
		"5": {
			"13": [
				1
			],
			"172": [
				1
			],
			"358": [
				1
			]
		},
		"6": {
			"18": [
				1
			],
			"177": [
				1
			],
			"363": [
				1
			]
		},
		"7": {
			"14": [
				1
			],
			"173": [
				1
			],
			"359": [
				1
			]
		},
		"8": {
			"19": [
				1
			],
			"178": [
				1
			],
			"364": [
				1
			]
		},
		"9": {
			"15": [
				1
			],
			"174": [
				1
			],
			"360": [
				1
			]
		}
	},
	"33": {
		"0": {
			"348": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"34": {
		"0": {
			"1": [
				1
			],
			"74": [
				1
			],
			"103": [
				1
			],
			"136": [
				1
			],
			"256": [
				1
			],
			"260": [
				1
			],
			"261": [
				1
			],
			"278": [
				1
			],
			"282": [
				1
			],
			"306": [
				1
			],
			"321": [
				1
			],
			"322": [
				1
			],
			"323": [
				1
			],
			"324": [
				1
			],
			"325": [
				1
			],
			"326": [
				1
			],
			"327": [
				1
			],
			"343": [
				1
			],
			"345": [
				1
			],
			"346": [
				1
			],
			"349": [
				1
			],
			"415": [
				1
			],
			"417": [
				1
			],
			"418": [
				1
			],
			"425": [
				1
			],
			"426": [
				1
			],
			"443": [
				1
			],
			"515": [
				1
			],
			"517": [
				1
			],
			"518": [
				1
			],
			"525": [
				1
			],
			"526": [
				1
			],
			"528": [
				1
			],
			"529": [
				1
			],
			"530": [
				1
			],
			"531": [
				1
			],
			"532": [
				1
			],
			"599": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			],
			"693": [
				1
			],
			"696": [
				1
			],
			"697": [
				1
			],
			"701": [
				1
			],
			"715": [
				1
			],
			"722": [
				1
			],
			"738": [
				1
			],
			"862": [
				1
			],
			"895": [
				1
			],
			"902": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"83": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"419": [
				1
			],
			"519": [
				1
			],
			"664": [
				1
			],
			"698": [
				1
			],
			"734": [
				1
			],
			"756": [
				1
			],
			"794": [
				1
			],
			"860": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"84": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"420": [
				1
			],
			"520": [
				1
			],
			"665": [
				1
			],
			"699": [
				1
			],
			"735": [
				1
			],
			"757": [
				1
			],
			"859": [
				1
			],
			"861": [
				1
			]
		},
		"3": {
			"2": [
				1
			],
			"148": [
				1
			],
			"154": [
				1
			],
			"160": [
				1
			],
			"652": [
				1
			]
		},
		"4": {
			"5": [
				1
			],
			"149": [
				1
			],
			"155": [
				1
			],
			"163": [
				1
			],
			"655": [
				1
			]
		},
		"5": {
			"7": [
				1
			],
			"150": [
				1
			],
			"156": [
				1
			],
			"165": [
				1
			],
			"657": [
				1
			]
		},
		"6": {
			"151": [
				1
			],
			"157": [
				1
			],
			"166": [
				1
			],
			"658": [
				1
			],
			"930": [
				1
			]
		},
		"7": {
			"9": [
				1
			],
			"152": [
				1
			],
			"158": [
				1
			],
			"168": [
				1
			],
			"660": [
				1
			]
		},
		"8": {
			"12": [
				1
			],
			"153": [
				1
			],
			"159": [
				1
			],
			"171": [
				1
			],
			"663": [
				1
			]
		},
		"9": {
			"255": [
				1
			]
		},
		"10": {
			"353": [
				1
			]
		}
	},
	"35": {
		"0": {
			"74": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"426": [
				1
			],
			"443": [
				1
			],
			"526": [
				1
			],
			"599": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			],
			"701": [
				1
			],
			"722": [
				1
			],
			"733": [
				1
			],
			"862": [
				1
			],
			"902": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"664": [
				1
			]
		}
	},
	"36": {
		"0": {
			"74": [
				1
			],
			"256": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			],
			"601": [
				1
			],
			"606": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"195": [
				1
			],
			"664": [
				1
			]
		}
	},
	"37": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"38": {
		"0": {
			"74": [
				1
			],
			"349": [
				1
			],
			"403": [
				1
			],
			"413": [
				1
			],
			"414": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"39": {
		"0": {
			"403": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			]
		}
	},
	"40": {
		"0": {
			"443": [
				1
			],
			"599": [
				1
			],
			"647": [
				1
			],
			"689": [
				1
			]
		}
	},
	"41": {
		"0": {
			"74": [
				1
			],
			"103": [
				1
			],
			"137": [
				1
			],
			"251": [
				1
			],
			"252": [
				1
			],
			"256": [
				1
			],
			"281": [
				1
			],
			"306": [
				1
			],
			"349": [
				1
			],
			"403": [
				1
			],
			"409": [
				1
			],
			"410": [
				1
			],
			"411": [
				1
			],
			"430": [
				1
			],
			"431": [
				1
			],
			"628": [
				1
			],
			"692": [
				1
			],
			"784": [
				1
			],
			"787": [
				1
			]
		},
		"1": {
			"21": [
				1
			],
			"138": [
				1
			],
			"182": [
				1
			],
			"195": [
				1
			],
			"639": [
				1
			],
			"664": [
				1
			],
			"780": [
				1
			],
			"782": [
				1
			],
			"785": [
				1
			]
		},
		"2": {
			"22": [
				1
			],
			"139": [
				1
			],
			"183": [
				1
			],
			"196": [
				1
			],
			"640": [
				1
			],
			"665": [
				1
			],
			"781": [
				1
			],
			"783": [
				1
			],
			"786": [
				1
			]
		},
		"3": {
			"64": [
				1
			],
			"250": [
				1
			],
			"678": [
				1
			]
		},
		"4": {
			"63": [
				1
			],
			"249": [
				1
			],
			"677": [
				1
			]
		}
	},
	"42": {
		"0": {
			"74": [
				1
			],
			"349": [
				1
			],
			"413": [
				1
			],
			"414": [
				1
			],
			"443": [
				1
			],
			"599": [
				1
			]
		},
		"1": {
			"557": [
				1
			],
			"1865": [
				1
			]
		},
		"2": {
			"558": [
				1
			],
			"1866": [
				1
			]
		},
		"3": {
			"559": [
				1
			],
			"1867": [
				1
			]
		},
		"4": {
			"560": [
				1
			],
			"1868": [
				1
			]
		},
		"5": {
			"561": [
				1
			],
			"1869": [
				1
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/grid-control/slot-arrangement-policies/slot-order-functions-config.json
// module id = 1829
// module chunks = 2